var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "depth-wrapper" }, [
    _c(
      "ul",
      { staticClass: "ex-tab-list" },
      [
        _c(
          "li",
          {
            staticClass: "ex-tab __pointer",
            class: {
              active: _vm.isShowSell && _vm.isShowBuy
            },
            on: {
              click: function($event) {
                return _vm.showTable(true, true)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("trade.depth.all")))])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "ex-tab __pointer",
            class: {
              active: _vm.isShowBuy && !_vm.isShowSell,
              "active-side": _vm.isShowSell && _vm.isShowBuy
            },
            on: {
              click: function($event) {
                return _vm.showTable(true, false)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("trade.depth.buy")))])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "ex-tab __pointer",
            class: {
              active: _vm.isShowSell && !_vm.isShowBuy,
              "active-side": _vm.isShowBuy && !_vm.isShowSell
            },
            on: {
              click: function($event) {
                return _vm.showTable(false, true)
              }
            }
          },
          [_c("span", [_vm._v(_vm._s(_vm.$t("trade.depth.sell")))])]
        ),
        _vm._v(" "),
        _c("merge-depth")
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "__center-tb-title" }, [
      _c("span", { staticClass: "__center-tb-item __ellipsis depth price" }, [
        _vm._v(
          _vm._s(
            _vm.$t("trade.priceTitle", {
              price: _vm.quoteTokenDetail
                ? _vm.quoteTokenDetail.originalSymbol
                : ""
            })
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "__center-tb-item left __ellipsis depth quantity" },
        [
          _vm._v(
            _vm._s(
              _vm.$t("trade.amountTitle", {
                amount: _vm.tradeTokenDetail
                  ? _vm.tradeTokenDetail.originalSymbol
                  : ""
              })
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "__center-tb-item __ellipsis depth amount" }, [
        _vm._v(
          _vm._s(
            _vm.$t("trade.quantityTitle", {
              quantity: _vm.quoteTokenDetail
                ? _vm.quoteTokenDetail.originalSymbol
                : ""
            })
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "depthContentWrapper", staticClass: "depth-content-wrapper" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showDepthTips,
                expression: "showDepthTips"
              }
            ],
            staticClass: "depth-tips",
            style: "top: " + _vm.top + "px"
          },
          [
            _vm.isInMiningRange
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(this.$t("tradeCenter.inMiningRange")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v(_vm._s(_vm.$t("trade.depth.avgPrice")))]),
              _vm._v(" "),
              _c("div", [_vm._v("≈ " + _vm._s(_vm.selectDepth.avgPrice))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("trade.depth.sum", {
                      symbol: _vm.tradeTokenDetail
                        ? _vm.tradeTokenDetail.originalSymbol
                        : ""
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.selectDepth.sumInTrade))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("trade.depth.sum", {
                      symbol: _vm.quoteTokenDetail
                        ? _vm.quoteTokenDetail.originalSymbol
                        : ""
                    })
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.selectDepth.sumInQuote))])
            ])
          ]
        ),
        _vm._v(" "),
        _c("depth-table", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowSell,
              expression: "isShowSell"
            }
          ],
          attrs: {
            isShowAll: _vm.isShowBuy && _vm.isShowSell,
            dataType: "sell",
            depthData: _vm.depthSell
          },
          on: { showTips: _vm.showSellTips, hideTips: _vm.hideTips }
        }),
        _vm._v(" "),
        _vm.isShowBuy && _vm.isShowSell
          ? _c("price", { staticClass: "border_all" })
          : _vm._e(),
        _vm._v(" "),
        _c("depth-table", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowBuy,
              expression: "isShowBuy"
            }
          ],
          attrs: {
            isShowAll: _vm.isShowBuy && _vm.isShowSell,
            dataType: "buy",
            depthData: _vm.depthBuy
          },
          on: { showTips: _vm.showBuyTips, hideTips: _vm.hideTips }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }